import { useSnackbar, SnackbarKey } from "notistack";
import { Button } from "@material-ui/core";

type Props = {
  snackbarKey: SnackbarKey;
};

const CloseButton = ({ snackbarKey }: Props) => {
  const { closeSnackbar } = useSnackbar();

  return (
    <Button
      onClick={() => closeSnackbar(snackbarKey)}
      color="inherit"
      size="small"
    >
      ✖
    </Button>
  );
};

export default CloseButton;
